import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBb8_pOl5XyQ3rm5amHV6LXVWN2Y_U1Sos",
  authDomain: "arc-tracker-40885.firebaseapp.com",
  projectId: "arc-tracker-40885",
  storageBucket: "arc-tracker-40885.firebasestorage.app",
  messagingSenderId: "121800005746",
  appId: "1:121800005746:web:27d15f787205368d65caeb"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'europe-west2');
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

export default app;